module.exports = __webpack_public_path__ + "img/product28801p.9cd09bac.png";